import { debounce } from '@quillbot/design-system';
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useLatestRef } from './useLatestRef';

export function useDebounceState<State>(value: State, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState<State>(value);
  useEffect(() => {
    const id = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debouncedValue;
}
/**
 * @param callback debounced function (IT HAS TO BE PURE FUNCTION)
 * @param delay delay in ms
 * @description Use this instead of useDebounce as it can
 * do a closure over component fields without using any
 * state to keep track of debouning.
 */
export function useDebounceFn<Callback = (...args: any[]) => any>(
  callback: Callback,
  delay = 500
): Callback {
  const callbackRef = useLatestRef<Callback>(callback);
  return useMemo(
    () => debounce(callbackRef.current as unknown as (...arg: any[]) => any, delay),
    [delay]
  ) as unknown as Callback;
}
